import { api } from "..";

import { NewUser } from "@/types/ApiResponses/User";

export interface UpdateUserPayload {
  id: number;
  password?: string;
  image?: string | null;
  balance?: number;
}

export async function updateUser(
  payload: UpdateUserPayload
): Promise<NewUser> {
  const { id, ...body } = payload;
  const res = await api.client.patch(`/users-new/${id}`, body);
  return res.data;
}
